import { faqItems, siteInfo } from '@/mocks/sports';
import { SchemaFAQPage } from '@/components/feature/SchemaOrg';

export default function FAQSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <SchemaFAQPage faqs={faqItems} />
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            您可能关心的问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            关于九游体育平台的常见疑问，我们在这里为您一一解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-100 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-500 group-open:text-background-50 transition-colors duration-200">
                  <i className="ri-add-line text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}